<template>
  <div class="vue-rqf-page">
    <!--
	<div v-if="$root.partnerId" class="partner-logo"><img src="/wp-content/plugins/autotaksering/requests/assets/img/codan_orig.png" /></div>
    -->
    <div id="contactinfo" class="contactinfo">

      <h3>Kontaktinfo</h3>

      <!-- field:name -->
      <label>
        <input type="text" v-model="$root.contact.name" name="" placeholder="Fornavn / Etternavn" required/>
        <span class="v-error" v-if="$root.requestErrors.contact_name" v-text="$root.requestErrors.contact_name"></span>
      </label>
      <!-- end field:name -->

      <!-- field:address -->
      <label>
        <input type="text" v-model="$root.contact.address" name="" placeholder="Adresse" required/>
        <span class="v-error" v-if="$root.requestErrors.contact_address"
              v-text="$root.requestErrors.contact_address"></span>
      </label>
      <!-- end field:address -->

      <!-- field:contact_email -->
      <label>
        <input type="email" v-model="$root.contact.email" name="" placeholder="E-post" required/>
        <span class="v-error" v-if="$root.requestErrors.contact_email"
              v-text="$root.requestErrors.contact_email"></span>
      </label>
      <!-- end field:contact_email -->

      <!-- field:contact_phone -->
      <label>
        <input type="tel" @input="$root.getContact" v-model="$root.contact.phone" placeholder="Mobilnummer" required/>
        <span class="v-error" v-if="$root.requestErrors.contact_phone"
              v-text="$root.requestErrors.contact_phone"></span>
      </label>
      <!-- end field:contact_phone -->

      <!-- field:company -->
      <label>
        <input type="text" v-model="$root.contact.company" placeholder="Firma" required/>
        <span class="v-error" v-if="$root.requestErrors.contact_company"
              v-text="$root.requestErrors.contact_company"></span>
      </label>
      <!-- end field:company -->

      <!-- field:car_id -->
      <label>
        <input type="text" @input="$root.getCarModel" v-model="$root.request.car_id" placeholder="Registreringsnummer"
               required/>
        <span class="v-error" v-if="$root.requestErrors.car_id" v-text="$root.requestErrors.car_id"></span>
      </label>
      <!-- end field:car_id -->

      <template v-if="$root.car.model">
        <div class="car-make-and-model">
          <img :src="$root.car.brand_logo">
          <div class="car-make-and-model-details">
            <div class="car-make-and-model-year" v-text="$root.car.year"></div>
            <div class="car-make-and-model-model" v-text="$root.car.producer + ' ' + $root.car.model"></div>
          </div>
        </div>
      </template>

      <!-- field:mileage -->
      <label>
        <input type="number" v-model="$root.request.mileage" placeholder="Kilometerstand" required/>
        <span class="v-error" v-if="$root.requestErrors.mileage" v-text="$root.requestErrors.mileage"></span>
      </label>
      <!-- end field:mileage -->

      <!-- field:damage_date -->
      <label>
        <date-picker placeholder="Skadedato" v-model="$root.request.damage_date" valueType="format"
                     :disabledDate="(date) => date >= new Date()"></date-picker>
        <span class="v-error" v-if="$root.requestErrors.damage_date" v-text="$root.requestErrors.damage_date"></span>
      </label>
      <!-- end field:damage_date -->

      <!-- field:insurance_company -->
      <label>
        <v-select placeholder="Forsikringsselskap" v-model="$root.request.insurance_company" :options="$root.companies"
                  :menu-props="{
   closeOnClick: true,
   closeOnContentClick: true,
  }"></v-select>
        <span class="v-error" v-if="$root.requestErrors.insurance_company"
              v-text="$root.requestErrors.insurance_company"></span>
      </label>
      <!-- end field:insurance_company -->

      <!-- field:consent -->
      <label class="checkbox">
        <input true-value="1" false-value="0" type="checkbox" v-model="$root.request.consent">
        <span>Jeg samtykker til lagring og bruk av mine personlige opplysninger.</span>
        <span class="v-error" v-if="$root.requestErrors.consent" v-text="$root.requestErrors.consent"></span>
      </label>
      <!-- end field:consent -->

      <!-- field:consent_second -->
      <label class="checkbox">
        <input true-value="1" false-value="0" type="checkbox" v-model="$root.request.consent_second">
        <span>Jeg aksepterer at kostaden for taksen faktureres meg og at faktura sendes per mail til oppgitt mailadresse. Kostnaden for taksten er 500,- inkl.mva.</span>
        <span class="v-error" v-if="$root.requestErrors.consent_second"
              v-text="$root.requestErrors.consent_second"></span>
      </label>
      <!-- end field:consent_second -->

      <div class="mps-actions">
        <button id="gtm-inquiry-submit" :disabled="$root.ui.loading" @click.prevent="$root.submitContact"
                class="button primary">Send forespørsel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  data() {
    return {
      disabledDates: {
        from: new Date(2016, 0, 5)
      },
    }
  },
  components: {DatePicker},
  methods: {}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Contact.vue?19dff010